export const API_URL = 'https://uchianat.ru';
export const API2_URL = 'https://learnmed.ru';
export const API5_URL = 'https://learnmed.ru';
export const RESOURCE_URL = 'https://uchianat.ru/resource';
export const BASE_URL_PURCHASE = 'https://learnmed.ru/resource';
